var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM2.4 12C2.4 17.3019 6.69807 21.6 12 21.6C17.3019 21.6 21.6 17.3019 21.6 12C21.6 6.69807 17.3019 2.4 12 2.4C6.69807 2.4 2.4 6.69807 2.4 12Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5753 16.9953C22.1629 17.3019 22.8939 17.0757 23.1402 16.4605C23.7707 14.8858 24.0619 13.1908 23.989 11.4871C23.899 9.38262 23.2566 7.33887 22.1264 5.56132C20.9962 3.78377 19.4179 2.33505 17.5504 1.36076C16.0385 0.572015 14.38 0.116707 12.6866 0.0196552C12.025 -0.0182649 11.5101 0.547732 11.5384 1.20987C11.5667 1.872 12.1282 2.378 12.7887 2.43245C14.0601 2.53726 15.3021 2.89483 16.4403 3.4886C17.9343 4.26804 19.1969 5.42702 20.1011 6.84906C21.0053 8.2711 21.5192 9.90609 21.5912 11.5897C21.6461 12.8723 21.443 14.1486 20.9986 15.3445C20.7677 15.9657 20.9877 16.6888 21.5753 16.9953Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSmall);
export default __webpack_public_path__ + "static/media/loader_small.a4d50b9fd2940e8d729ccd1872170e72.svg";
export { ForwardRef as ReactComponent };